(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const playButtons = document.querySelectorAll('.hero__video-play-button');
    
    playButtons.forEach(button => {
      button.addEventListener('click', function() {
        const videoTarget = this.getAttribute('data-video-target');
        const videoWrapper = this.closest('.hero__video-wrapper');
        
        if (videoWrapper) {
          // Determine which video to target based on the data attribute
          let video;
          if (videoTarget.includes('mobile')) {
            // Target mobile video (hidden on desktop)
            video = videoWrapper.querySelector('video.hidden--desktop');
          } else {
            // Target desktop video (hidden on mobile)
            video = videoWrapper.querySelector('video:not(.hidden--desktop)');
          }
          
          if (video) {
            // Hide the play button
            this.style.display = 'none';
            
            // Hide the appropriate poster image
            const poster = videoWrapper.querySelector(videoTarget.includes('mobile') ? '.hero__video-poster.hidden--desktop' : '.hero__video-poster:not(.hidden--desktop)');
            if (poster) {
              poster.style.display = 'none';
            }
            
            // Play the video
            video.play().catch(error => {
              console.log('Video play failed:', error);
              // Show the play button again if play fails
              this.style.display = 'flex';
              if (poster) {
                poster.style.display = 'block';
              }
            });
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
